import { getTheme, themeRegistry } from './themeRegistry.js';
import { THEME_IDS } from './themeIds.js';

/**
 * @param {import('./themeRegistry.js').ThemeDefinition} theme
 */
export function syncBodyTheme(theme) {
  Object.values(themeRegistry).forEach((entry) => {
    if (entry.bodyClass) {
      document.body.classList.remove(entry.bodyClass);
    }
  });

  if (theme.bodyClass) {
    document.body.classList.add(theme.bodyClass);
  }
}

export function clearBodyTheme() {
  syncBodyTheme(getTheme(THEME_IDS.DEFAULT));
}
